// Official circle-U mark: white circle, bold navy U with a cross-bar on the right stem.
// Never warp, rotate, outline, shadow, or glow. Solid navy/orange plates only.
export const UMark = ({ size = 40, on = "navy", className = "" }) => {
  const plate = on === "navy" ? "#FFFFFF" : "#0F1729";
  const glyph = on === "navy" ? "#0F1729" : "#FFFFFF";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="u-topia circle-U mark"
      className={className}
    >
      <circle cx="24" cy="24" r="24" fill={plate} />
      <path
        d="M15 12.5V27a9 9 0 0 0 18 0V12.5"
        stroke={glyph}
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path d="M29 19h10" stroke={glyph} strokeWidth="4.5" strokeLinecap="round" />
    </svg>
  );
};

// Wordmark lockup: [circle U] u-topia - always lowercase. Nav and footer only.
export const LogoLockup = ({ on = "navy", markSize = 30, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <UMark size={markSize} on={on} />
    <span
      className={`text-lg font-semibold lowercase tracking-tight ${
        on === "navy" ? "text-white" : "text-navy"
      }`}
    >
      u-topia
    </span>
  </span>
);
